import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Condition } from '../../../models/condition.model';
import { Component as ComponentModel } from '../../../models/component.model';

@Component({
  selector: 'app-add-condition-modal',
  templateUrl: './add-condition-modal.component.html',
  styleUrl: './add-condition-modal.component.css'
})
export class AddConditionModalComponent {
  selectedComponent: string = '';
  possibleSources: ComponentModel[] = []; //all the page components, except those already in the current component and the component itself.

  constructor(private dialogRef: MatDialogRef<AddConditionModalComponent>, @Inject(MAT_DIALOG_DATA) public data: { sources: ComponentModel[] }) {
    this.possibleSources = data.sources;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    const newCondition : Condition = {
      componentId: this.selectedComponent,
      rules: []
    };

    this.dialogRef.close(newCondition);
  }
}
